import React, { createContext, useReducer } from "react";
import PropTypes from "prop-types";

const initialState = {
  authUser: null,
  authRoles: [],
  authPermissions: [],
  isAuthenticated: false,
};

export const AuthContext = createContext(initialState);

const authReducer = (state, action) => {
  let parsedRoles;
  switch (action.type) {
    case "LOGIN_START":
      return { authUser: null, authRoles: [], isAuthenticated: false };

    case "LOGIN_SUCCESS":
      try {
        parsedRoles =
          typeof action.payload.authRoles === "string"
            ? JSON.parse(action.payload.authRoles) // Only parse if it's a string
            : action.payload.authRoles || []; // Use as-is if it's already an array
      } catch (error) {
        console.error("Error parsing authRoles:", error);
        parsedRoles = []; // Default to an empty array
      }

      return {
        authUser: action.payload.authUser,
        authRoles: Array.isArray(parsedRoles) ? parsedRoles : [parsedRoles], // Ensure it's always an array
        isAuthenticated: true,
      };

    case "LOGOUT":
      return { authUser: null, authRoles: [], isAuthenticated: false };

    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  /**
   * Helper functions to check roles.
   */
  const hasRole = (role) => state.authRoles.includes(role);
  const hasAnyRole = (roles) =>
    roles.some((role) => state.authRoles.includes(role));
  const hasAllRoles = (roles) =>
    roles.every((role) => state.authRoles.includes(role));

  return (
    <AuthContext.Provider
      value={{
        authUser: state.authUser,
        authRoles: state.authRoles,
        isAuthenticated: state.isAuthenticated,
        hasRole,
        hasAnyRole,
        hasAllRoles,
        dispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
